// team — dark slide (v15 slide 11): third-party cards in the top band under the
// PROJEKTORGANISATION rule, then the two NAVEN people from the library (photo with gold
// frame, serif name, mono role in gold, bio) — left card w438 at x206, right w410 at x806.
import type { TeamBound, TeamContent } from '../../../../shared/deckTypes.js';
import { Abs, Brand, Dkp, Eyebrow, PageNo, Rule } from './chrome.js';

const PARTY_X = [64, 464, 864];
const PARTY_W = 352;
/** Person geometry, generic: [photoX, textX, bioW]. */
const PERSON = [
  { photoX: 64, textX: 206, bioW: 438 },
  { photoX: 664, textX: 806, bioW: 410 },
] as const;

export default function TeamPreview({ content, bound, pageNo }: {
  content: TeamContent;
  bound?: TeamBound;
  pageNo?: number | null;
}) {
  const c = content;
  const parties = (c.parties ?? []).slice(0, 3);
  const persons = (bound?.persons ?? []).slice(0, 2);

  return (
    <Dkp variant="dark">
      <Eyebrow text={c.eyebrow ?? ''} />
      <Abs x={64} y={84} w={900}>
        <div className="dkp-title" style={{ color: '#F3F1EC' }}>{c.title}</div>
      </Abs>

      {/* the organisation band (frozen header) */}
      {parties.length > 0 ? (
        <>
          <Abs x={64} y={169.7}><span className="dkp-th">PROJEKTORGANISATION</span></Abs>
          <Rule x={64} y={193.7} w={1152} color="#3A3C41" />
        </>
      ) : null}
      {parties.map((p, i) => (
        <div key={i}>
          <Abs x={PARTY_X[i]} y={215.7} w={PARTY_W}>
            <span className="dkp-mono" style={{
              fontSize: 9.3, letterSpacing: '.11em', textTransform: 'uppercase', color: '#C8A96E',
            }}>{p.label}</span>
          </Abs>
          <Abs x={PARTY_X[i]} y={237.7} w={PARTY_W}>
            <div className="dkp-serif" style={{ fontSize: 17.3, color: '#F3F1EC' }}>{p.name}</div>
          </Abs>
          <Abs x={PARTY_X[i]} y={267.7} w={PARTY_W}>
            <div style={{ fontSize: 12, fontWeight: 500, color: '#D9D6CF', lineHeight: 1.45 }}>{p.body}</div>
          </Abs>
        </div>
      ))}

      {/* the two people, from the library */}
      {persons.map((person, i) => {
        const g = PERSON[i];
        if (!g) return null;
        return (
          <div key={person.personId}>
            <Abs x={g.photoX} y={397.4} w={120} h={120} style={{ border: '1px solid #C8A96E' }}>
              {person.photoKey ? (
                <img src={person.photoKey} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : null}
            </Abs>
            <Abs x={g.textX} y={390.6} w={g.bioW}>
              <div className="dkp-serif" style={{ fontSize: 22.7, color: '#F3F1EC' }}>{person.name}</div>
            </Abs>
            <Abs x={g.textX} y={421.3} w={g.bioW}>
              <span className="dkp-mono" style={{
                fontSize: 9.3, letterSpacing: '.1em', textTransform: 'uppercase', color: '#C8A96E',
              }}>{person.roleLabel}</span>
            </Abs>
            <Abs x={g.textX} y={439.3} w={g.bioW}>
              <div style={{ fontSize: 12, fontWeight: 500, color: '#D7D7CE', lineHeight: 1.55 }}>
                {person.bio}
              </div>
            </Abs>
          </div>
        );
      })}

      <Brand light />
      <PageNo n={pageNo} light />
    </Dkp>
  );
}
